// Primary 5 English Learning Data
// Combined from p5Data-part1.js and p5Data-part2.js
// Based on Primary English Learning P5 Topics.txt

import { p5DataPart1 } from './p5Data-part1';
import { p5DataPart2 } from './p5Data-part2';

export const p5Data = {
  gradeId: p5DataPart1.gradeId,
  gradeName: p5DataPart1.gradeName,
  objectives: p5DataPart1.objectives,
  keySkills: p5DataPart1.keySkills,
  topics: [
    ...p5DataPart1.topics,
    ...p5DataPart2.topics
  ]
}; 